module.exports = __webpack_public_path__ + "static/img/abMapFont.6edb42e3.png";